import { OrderCardHeader as KyokoOrderCardHeader } from '@talos/kyoko';
import {
  shouldShowEntityUnifiedLiquidityMarketTooltip,
  useEntityUnifiedLiquidityMarketTooltipGroups,
} from '../../MarketSelector/entityUnifiedLiquidityMarketTooltipContent';
import { UnifiedLiquidityTooltipIndicator } from '../../MarketSelector/UnifiedLiquidityTooltipIndicator';
import { PredictionOutcomeTag } from '../../PredictionMarkets/PredictionOutcomeTag';

type OrderCardHeaderProps = React.ComponentProps<typeof KyokoOrderCardHeader>;

export const OrderCardHeader = (props: OrderCardHeaderProps) => {
  const unifiedLiquidityTooltipGroups = useEntityUnifiedLiquidityMarketTooltipGroups(props.order);
  const showUnifiedLiquidityTooltip = shouldShowEntityUnifiedLiquidityMarketTooltip(
    props.order,
    unifiedLiquidityTooltipGroups
  );
  const expressedOutcome = 'ExpressedOutcome' in props.order ? props.order.ExpressedOutcome : undefined;

  return (
    <KyokoOrderCardHeader
      {...props}
      symbolSuffix={<PredictionOutcomeTag outcome={expressedOutcome} />}
      unifiedLiquidityIndicator={
        showUnifiedLiquidityTooltip ? (
          <UnifiedLiquidityTooltipIndicator
            baseSymbol={props.order.Symbol}
            groups={unifiedLiquidityTooltipGroups}
            dataTestId="order-card-header-unified-liquidity-tooltip"
            statusTestIdPrefix="order-card-header-unified-liquidity-tooltip-status"
          />
        ) : undefined
      }
    />
  );
};
